import styled                       from "styled-components";

import { cssFlexColumn, 
         cssFlexRow               } from "src/providers/theme/shared";



type ResultDialogLookAndFeel = {
  padding: number[]; 
  paddingContainer: string;
  gap: number[];
  marginTop: number; 
}

const result_dialog: ResultDialogLookAndFeel = {
  padding: [0, 2, 10, 16, 20, 32],
  paddingContainer: '2px 20px 32px 20px',
  gap: [16, 20],
  marginTop: 32
}

export type ResultDialogVariants = 'result_dialog_main'

export const result_dialog_variants: Map<ResultDialogVariants, ResultDialogLookAndFeel> = new Map<ResultDialogVariants, ResultDialogLookAndFeel>([
  ['result_dialog_main', result_dialog],
]);
        
export const Container = styled.div<{
  lookAndFeel: ResultDialogLookAndFeel
}>`
  ${cssFlexColumn};
  padding: ${(args) => args.lookAndFeel.paddingContainer};
  gap: ${(args) => args.lookAndFeel.gap[1]}px;
`;

export const LabelContainer = styled.div<{
  lookAndFeel: ResultDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap[0]}px;
  padding: ${(args) => args.lookAndFeel.padding[3]}px;
`;

export const RadioButtonContainer = styled.div<{
  lookAndFeel: ResultDialogLookAndFeel
}>`
  ${cssFlexRow};
  padding: ${(args) => args.lookAndFeel.padding[0]} ${(args) => args.lookAndFeel.padding[2]}px;
`;

export const TextAreaContainer = styled.div<{
  lookAndFeel: ResultDialogLookAndFeel
}>`
  ${cssFlexRow};
`;

export const ActionsContainer = styled.div<{
  lookAndFeel: ResultDialogLookAndFeel
}>`
  ${cssFlexColumn};
  margin-top: ${(args) => args.lookAndFeel.marginTop}px;
`;
